import { useContext, useEffect, useState } from "react";
import { useMutation } from "react-query";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchPaymentMethods,
  menuPayInstoreDelivery,
  menuProcessPayment,
} from "../../../../../services/inventory";
import { useNavigate } from "react-router-dom";
import { ToastContext } from "../../../../../hooks/context";
import { clearAllMenuCartItems } from "../../../../../store/modules/menuCart";
import { pathConstants } from "../../../../../routes/pathContants";
import { hasAcceptedPoliciesAgreement } from "../../../../../store/modules/policy";
import useKonetPayCheckout from "../../../../../hooks/useKonetPayCheckout";

const usePayForOrder = ({
  // selectedOrderType,
  setShowPayForOrder,
  setShowCartItems,
  menuObjectDetail,
}) => {
  const dispatch = useDispatch();
  const triggerToast = useContext(ToastContext);
  const { menuCartItems } = useSelector((state) => state.menuCartReducer);
  const { acceptedPolicies } = useSelector((state) => state.policiesReducer);
  const [paymentMethod, setPaymentMethod] = useState(null);
  const [preferredPaymentMethod, setPreferredPaymentMethod] = useState(null);
  const navigate = useNavigate();
  const { open: openKonetPayCheckout } = useKonetPayCheckout();

  const {
    isLoading: isLoadingPayInstoreDelivery,
    mutate: mutatePayInstoreDelivery,
  } = useMutation({
    mutationFn: (data) => menuPayInstoreDelivery(data),
    onSuccess: (data) => {
      triggerToast(data.data.detail, "success");
      if (window.innerWidth > 850) {
        setShowCartItems(false);
      }
      dispatch(clearAllMenuCartItems());
      const orderId = localStorage.getItem("order_id");
      localStorage.removeItem("order_id");
      setShowPayForOrder(false);

      navigate(
        pathConstants.INVENTORY_STOREFRONT_ORDER_STATUS({
          menuId: menuObjectDetail?.id,
          id: orderId,
        }),
      );
    },
  });

  const { isLoading: isLoadingProcessPayment, mutate: mutateProcessPayment } =
    useMutation({
      mutationFn: (data) => menuProcessPayment(data),
      onSuccess: async (data) => {
        const paymentData = data?.data?.data;
        const useKonetPaySdk =
          process.env.REACT_APP_USE_KONETPAY_SDK === "true";

        if (paymentMethod?.type === "KONETPAY" && useKonetPaySdk) {
          const initData = paymentData?.init_data;
          const transaction = {
            reference: initData?.reference,
            accessCode: initData?.access_code,
            authorizationUrl: initData?.authorization_url,
          };

          const outcome = await openKonetPayCheckout(transaction);

          if (outcome?.status === "success") {
            const orderId = localStorage.getItem("order_id");
            dispatch(clearAllMenuCartItems());
            navigate(
              pathConstants.INVENTORY_STOREFRONT_ORDER_STATUS({
                menuId: menuObjectDetail?.id,
                id: orderId,
              }),
            );
          }
          return;
        }

        window.location.href = paymentData?.init_data?.url;
      },
    });

  const {
    isLoading: isLoadingPaymentGateways,
    mutate: mutatePaymentGateway,
    data: dataPaymentGateways,
  } = useMutation({
    mutationFn: (data) => fetchPaymentMethods(data),
    onError: (error) => {
      triggerToast(`${error.response.data.message}`, "warning");
    },
  });

  const handleProcessPayment = () => {
    // if (!paymentMethod && selectedOrderType !== "DELIVERY") {
    //   return triggerToast(
    //     "Choose your preferred payment method to make payment",
    //     "warning",
    //   );
    // }

    if (menuObjectDetail?.id) {
      const guest_token = localStorage.getItem("guest_token");
      const order_id = localStorage.getItem("order_id");

      if (preferredPaymentMethod === "Pay Online") {
        mutateProcessPayment({
          guest_token,
          order_id,
          storefront_id: menuObjectDetail.id,
          accepted_policies: acceptedPolicies,
          callback_url:
            window.location.origin +
            pathConstants.INVENTORY_STOREFRONT_ORDER_STATUS({
              menuId: menuObjectDetail.id,
              id: order_id,
            }),
          merchant_token: paymentMethod.merchant_token,
          payment_method: paymentMethod.type,
        });
      } else if (preferredPaymentMethod === "Pay In-store") {
        mutatePayInstoreDelivery({
          guest_token,
          order_id,
          storefront_id: menuObjectDetail.id,
          payment_point: "IN_STORE",
        });
      } else {
        mutatePayInstoreDelivery({
          guest_token,
          order_id,
          accepted_policies: acceptedPolicies,
          storefront_id: menuObjectDetail.id,
          payment_point: "ON_DELIVERY",
        });
      }
    }
    dispatch(hasAcceptedPoliciesAgreement(false));
  };

  useEffect(() => {
    if (dataPaymentGateways?.data?.data?.length === 1) {
      setPaymentMethod(dataPaymentGateways?.data?.data?.[0]);
    }
  }, [dataPaymentGateways]);

  useEffect(() => {
    if (menuObjectDetail?.id) {
      mutatePaymentGateway({
        storefront_id: menuObjectDetail.id,
        accepted_policies: acceptedPolicies,
      });
    }
  }, [menuObjectDetail]);

  return {
    isLoadingPayInstoreDelivery,
    isLoadingProcessPayment,
    isLoadingPaymentGateways,
    dataPaymentGateways,
    menuCartItems,
    paymentMethod,
    preferredPaymentMethod,
    store: menuObjectDetail?.store,
    menuObjectDetail,
    setPaymentMethod,
    setPreferredPaymentMethod,
    handleProcessPayment,
  };
};

export default usePayForOrder;
